import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LangContext";
import { BLOG_ARTICLES } from "./blog/articles";
import { ArrowUpRight, Clock } from "lucide-react";

const COPY = {
  de: {
    eyebrow: "— Ayurveda Journal",
    heading: "Wissen, das in den Alltag passt.",
    lead:
      "Kurze, ehrliche Artikel über ayurvedische Praxis in der Schweiz – von Behandlungen bis Ernährung, aus über einem Jahrzehnt Erfahrung im Aargauer Seetal.",
    readTime: "Min. Lesezeit",
    readMore: "Artikel lesen",
  },
  en: {
    eyebrow: "— Ayurveda Journal",
    heading: "Wisdom that fits your day.",
    lead:
      "Short, honest articles on ayurvedic practice in Switzerland – from treatments to nutrition, drawn from over a decade of experience in the Seetal valley.",
    readTime: "min read",
    readMore: "Read article",
  },
};

export default function Blog() {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.de;

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20" data-testid="blog-index-page">
      <div className="max-w-3xl">
        <div className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">{c.eyebrow}</div>
        <h1 className="font-display text-5xl lg:text-6xl text-ink leading-tight">{c.heading}</h1>
        <p className="mt-6 text-ink-muted leading-relaxed">{c.lead}</p>
      </div>

      <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {BLOG_ARTICLES.map((a) => {
          const t = a[lang] || a.de;
          return (
            <Link
              key={a.slug}
              to={`/blog/${a.slug}`}
              className="group flex flex-col bg-white border border-border rounded-md overflow-hidden hover:-translate-y-1 hover:shadow-[0_18px_40px_-20px_rgba(43,31,22,0.35)] transition-all duration-300"
              data-testid={`blog-card-${a.slug}`}
            >
              <div className="aspect-[4/3] overflow-hidden bg-muted">
                <img
                  src={a.image}
                  alt=""
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center gap-3 text-xs text-ink-muted mb-3">
                  <Clock className="w-3 h-3" strokeWidth={1.5} />
                  <span>
                    {a.readMin} {c.readTime}
                  </span>
                </div>
                <h2 className="font-display text-2xl text-ink leading-snug mb-3">{t.title}</h2>
                <p className="text-sm text-ink-muted leading-relaxed mb-6 flex-1">{t.excerpt}</p>
                <span className="inline-flex items-center gap-1.5 text-sm uppercase tracking-wider text-terracotta">
                  {c.readMore}
                  <ArrowUpRight
                    className="w-4 h-4 transition-transform group-hover:rotate-45"
                    strokeWidth={1.5}
                  />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
